module.exports = __webpack_public_path__ + "img/jobs.b5fb6268.png";